import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    paramName: { type: String, default: "activity_filter" },
    frameId: { type: String, default: "activity-filter-results" }
  }

  connect() {
    this.updateActiveStates()
  }

  select(event) {
    const filter = event.currentTarget.dataset.filter
    this.updateUrl(filter)
    this.updateActiveStates()
    this.refreshFrame()
  }

  updateUrl(filter) {
    const url = new URL(window.location.href)

    if (filter && filter !== "") {
      url.searchParams.set(this.paramNameValue, filter)
    } else {
      url.searchParams.delete(this.paramNameValue)
    }

    history.pushState({}, "", url.toString())
  }

  updateActiveStates() {
    const currentFilter = this.getCurrentFilter()

    this.element.querySelectorAll("[data-filter]").forEach(button => {
      const buttonFilter = button.dataset.filter
      const isActive = buttonFilter === currentFilter || (buttonFilter === "" && !currentFilter)

      if (isActive) {
        button.className = "inline-flex items-center px-3 py-1.5 text-sm font-medium rounded-full bg-indigo-100 border border-indigo-500 text-indigo-700 transition-colors cursor-pointer"
      } else {
        button.className = "inline-flex items-center px-3 py-1.5 text-sm font-medium rounded-full bg-white border border-gray-300 text-gray-700 hover:bg-gray-50 transition-colors cursor-pointer"
      }
    })
  }

  getCurrentFilter() {
    const url = new URL(window.location.href)
    return url.searchParams.get(this.paramNameValue)
  }

  refreshFrame() {
    const frame = document.getElementById(this.frameIdValue)
    if (frame) {
      const url = new URL(window.location.href)
      frame.src = url.toString()
    }
  }
}
